export type OriginRegion = 'uk' | 'com' | 'unknown'

export const resolveOriginRegion = (originDomain?: string | null): OriginRegion => {
    if (!originDomain) return 'unknown'

    const value = originDomain.trim().toLowerCase()
    if (!value) return 'unknown'

    let hostname = value
    try {
        hostname = new URL(value.includes('://') ? value : `https://${value}`).hostname
    } catch {
        return 'unknown'
    }

    if (hostname === 'banxe.uk' || hostname.endsWith('.banxe.uk')) return 'uk'
    if (hostname === 'banxe.com' || hostname.endsWith('.banxe.com')) return 'com'

    return 'unknown'
}
